export const formatLabel = (text) => {
  if (!text) return text;

  // Only format if the text is entirely uppercase
  if (text === text.toUpperCase()) {
    return text
      .split(' ')
      .map(word => {
        if (word.length === 0) return '';
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  return text;
};
